module.exports = __webpack_public_path__ + "static/img/2.505760f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.jpg
// module id = 45
// module chunks = 1 4